
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"210","height":"210","viewBox":"0 0 55.563 55.562"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#46c002","d":"M40.297 15.374l4.49 4.49L24.462 40.19 10.775 26.502l4.49-4.49 9.197 9.196z"}}),_c('path',{attrs:{"d":"M27.778 2.4C13.765 2.402 2.4 13.766 2.4 27.785c0 14.015 11.364 25.378 25.377 25.378 14.02 0 25.384-11.363 25.384-25.378 0-14.02-11.364-25.383-25.384-25.383zm0 1.569c13.154 0 23.816 10.661 23.816 23.815 0 13.148-10.662 23.81-23.816 23.81-13.148 0-23.81-10.662-23.81-23.81 0-13.154 10.662-23.815 23.81-23.815z","clip-rule":"evenodd","fill":"none","stroke":"#46c002","stroke-width":"3.9686999999999997","stroke-miterlimit":"10"}})])
          )
        }
      }
    